import type { ReactNode, RefObject } from "react";
import React from "react";
import { TransitionGroup } from "react-transition-group";

import type {
  WPAsyncPageGroupDescriptor,
  WPPageDescriptor,
  WPPageGroupDescriptor,
} from "../../../../models/WPPageDescriptor";
import { CSSRefTransition } from "../../../components/atoms/transition.css";
import { fadeInTransitionDurationMs } from "../../styles/App";

import { LinkList } from "./LinkList";
import * as styles from "./styles/SubNavigation";

type Props = {
  items: Array<| WPPageGroupDescriptor
    | WPPageDescriptor
    | WPAsyncPageGroupDescriptor>;
  isAuthorized: boolean;
};

export function SubNavigation({ items, isAuthorized }: Props): ReactNode {
  return (
    <TransitionGroup component={null}>
      {(items.length > 0 || !isAuthorized) && (
        <CSSRefTransition timeout={fadeInTransitionDurationMs}>
          {(ref) => (
            <aside ref={ref} className={styles.asideCls}>
              <TransitionGroup component={null}>
                <CSSRefTransition
                  key={generateSubNavigationKey(items, isAuthorized)}
                  timeout={100}
                >
                  {(ref) =>
                    isAuthorized ? (
                      <nav ref={ref} className={styles.navCls}>
                        <LinkList items={items} />
                      </nav>
                    ) : (
                      <Skeleton ref={ref} />
                    )
                  }
                </CSSRefTransition>
              </TransitionGroup>
            </aside>
          )}
        </CSSRefTransition>
      )}
    </TransitionGroup>
  );
}

function Skeleton(props: {
  ref?: RefObject<HTMLUListElement | null>;
}): ReactNode {
  return (
    <ul ref={props.ref} className={styles.skeletonCls}>
      <li className={styles.skeletonLineCls} />
      <li className={styles.skeletonLineCls} />
      <li className={styles.skeletonLineCls} />
      <li className={styles.skeletonLineCls} />
    </ul>
  );
}

function generateSubNavigationKey(
  items: Array<| WPPageGroupDescriptor
    | WPPageDescriptor
    | WPAsyncPageGroupDescriptor>,
  isAuthorized: boolean,
): string {
  return isAuthorized ? items.map((item) => item.path).join() : "unauthorized";
}
